import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-arrow-left",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m12 19-7-7 7-7" }), /* @__PURE__ */ _jsx("path", { d: "M19 12H5" })]
});
export default SvgArrowLeft;
